import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";

const preSave = (payload) => {
  if (payload.admins) {
    payload.admins = payload?.admins?.map((i) => ({ _id: i._id, account: { _id: i?.account?._id || i.accountId } }));
  }
  return payload;
};

export const organizationAssetGroupCategory = createCrudVuexModule({
  namespaced: true,
  path: "/asset-group-category",
  preSave,
  actions: {
    async addFromLibrary({ commit }, payload) {
      commit("isUpdating", true);
      try {
        const response = await rest.post("/asset-group-category/add-from-library", payload);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },

    async updateAdmins({ getters, commit, dispatch }, payload) {
      commit("isUpdating", true);
      try {
        payload = preSave(payload);
        const response = await rest.put(`/asset-group-category/admins`, payload);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
  },
});

export const organizationAssetGroup = createCrudVuexModule({
  namespaced: true,
  path: "/asset-group-category-asset-group",
  persistent: ["assetGroup"],
  preSave,
  state: {
    assetGroup: undefined,
    isDownloading: false,
  },
  getters: {
    assetGroup: (state) => state.assetGroup,
    isDownloading: (state) => state.isDownloading,
  },
  mutations: {
    assetGroup: (state, value) => (state.assetGroup = value),
    isDownloading: (state, value) => (state.isDownloading = value),
  },
  actions: {
    async addFromLibrary({ commit }, payload) {
      commit("isUpdating", true);
      try {
        const response = await rest.post("/asset-group-category-asset-group/add-from-library", payload);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },

    async updateAdmins({ getters, commit, dispatch }, payload) {
      commit("isUpdating", true);
      try {
        const payload = preSave(payload);
        const response = await rest.put(`/asset-group/admins`, payload);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
    async fetchDetail({ getters, commit, dispatch }, id) {
      commit("isUpdating", true);
      try {
        const response = await rest.get(`/asset-group-category-asset-group/${id}`);
        commit("assetGroup", response.data);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
    async download({ commit }, payload) {
      commit("isDownloading", true);
      try {
        const response = await rest.post("/asset-group-category-asset-group/download", payload);
        return response;
      } finally {
        commit("isDownloading", false);
      }
    },
  },
});
